export default __webpack_public_path__ + "static/media/icc.cd8122b5.jpg";